import { render, staticRenderFns } from "./add-news.vue?vue&type=template&id=584672cf&scoped=true&"
import script from "./add-news.vue?vue&type=script&lang=js&"
export * from "./add-news.vue?vue&type=script&lang=js&"
import style0 from "./add-news.vue?vue&type=style&index=0&id=584672cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584672cf",
  null
  
)

export default component.exports